import type { UpdateReport } from 'src/api';
import type { DynamicQuestionAnswerValue } from 'src/components/molecules';
import type { SaveAnswerInputType } from 'src/graphql/generated';
import { FormCategoryId } from 'src/graphql/formManagement/formCategories';

export type AnswersState = Record<string, DynamicQuestionAnswerValue>;

export const QUESTIONNAIRE_QUERY_PARAMS = {
  isActive: true,
  status: 'active',
  formCategoryId: FormCategoryId.SPEAK_UP,
};

export interface ManualIntakeDynamicQuestionsPayload {
  questionnaireId: string;
  responseId?: string | null;
  answers: SaveAnswerInputType[];
}

export interface ManualIntakeDynamicQuestionsRef {
  getDynamicQuestionsPayload: () => ManualIntakeDynamicQuestionsPayload | null;
}

export interface SubmitReportPayload {
  questionnaireId: string;
  responseId?: string | null;
  answers: ManualIntakeDynamicQuestionsPayload['answers'];
  attestationAccepted: boolean;
}

export interface ManualIntakeDynamicQuestionsProps {
  initialQuestionnaireId?: string | null;
  initialResponseId?: string | null;
  initialAnswers?: AnswersState;
  savedResponseId?: string | null;
  evidenceUploadReportId?: string | null;
  /** When set, disclosure case query is invalidated after QA attachment register/delete succeeds. */
  disclosureCaseInvalidateCaseId?: string | null;
  isDraftQuestionnaireResponseLoading?: boolean;
  canSelectQuestionnaire?: boolean;
  canSubmitReport?: boolean;
  isSubmittingReport?: boolean;
  currentReport: UpdateReport | null;
  updateReport: (report: UpdateReport) => void;
  onSubmitReport?: (payload: SubmitReportPayload) => void;
  onSubmitReportFromReview?: (payload: SubmitReportPayload) => void;
}
